module.exports = __webpack_public_path__ + "static/media/guesty-logo.e03b3482.png";